//defaults to be used for medscape only
window.beaconDefaults = {
    globReqDefault : {
        s_pagenum: "1"
    }
}